import { Component, Inject, Injector, INJECTOR } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoomWithData } from '../../server-services/query-records/room-records';
import { RoomService } from '../../server-services/room.service';
import { CollectionUploadConflictPolicy } from '../../services/download-manager-service';
import { NanoDialogBaseComponent } from '../nano-base-dialog';

export type CollectionUploadStartDialogData = {
  pathToUpload: string;
  conflictPolicy: CollectionUploadConflictPolicy;
  roomId: string;
};

@Component({
  selector: 'app-collection-upload-start-dialog',
  templateUrl: './collection-upload-start-dialog.component.html',
  styleUrl: './collection-upload-start-dialog.component.scss',
})
export class CollectionUploadStartDialogComponent extends NanoDialogBaseComponent<CollectionUploadStartDialogComponent> {
  public roomData: RoomWithData;
  public CONFLICT_POLICY = CollectionUploadConflictPolicy;

  constructor(
    @Inject(INJECTOR) injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: CollectionUploadStartDialogData,
    private roomService: RoomService
  ) {
    super(injector);
    this.roomService
      .getRoom(this.data.roomId)
      .then((roomData) => {
        this.roomData = roomData;
      })
      .catch((err) => {
        console.error('could not load room data', err);
      });
  }

  public close() {
    this.dialogRef.close();
  }

  public send() {
    this.dialogRef.close(this.data);
  }
}
